import { ComponentProps, JSX } from "solid-js";
import c from "class-c";

import styles from "./Banner.module.scss";

declare namespace Banner {
  type Position = "top" | "bottom";
  type Props = ComponentProps<"div"> & {
    class?: string;
    position: Position;
    children: JSX.Element;
  };
}

function Banner({
  class: className,
  position,
  children,
  ...props
}: D<Banner.Props>) {
  return (
    <div
      class={c`${styles["banner"]} ${styles[position]} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export default Banner;
